import React from "react";
import { HeaderGroup } from "react-table";

import { DoctorsListHeadingItem } from "./DoctorsListHeadingItem";
import { InsuranceDoctorDto } from "@apiModels/Insurance/InsuranceDoctorDto.csharp";

interface DoctorsListHeadingsProps {
  headerGroup: HeaderGroup<InsuranceDoctorDto>;
}

export const DoctorsListHeadings: React.FC<DoctorsListHeadingsProps> = (
  props
) => {
  const { headerGroup } = props;
  const { getHeaderGroupProps, headers } = headerGroup;

  return (
    <thead className="doctorsListHeadings">
      <tr className="doctorsListHeadings__row" {...getHeaderGroupProps()}>
        {headers.map((column) => (
          <DoctorsListHeadingItem key={column.id} column={column} />
        ))}
      </tr>
    </thead>
  );
};
